const de = {
  title: 'Förderinfos',
  categories: 'Kategorien',
  columns: {
    title: 'Programm',
    description: 'Beschreibung',
    requirements: 'Vorausetzungen',
    durationAndQuote: 'Dauer und Quote',
    process: 'Verfahren',
    deadline: 'Stichtag',
    focus: 'Schwerpunkte',
    contact: 'Ansprechpartner',
    noDeadline: 'Kein Stichtag'
  },
  create: {
    createModalTitle: 'Neue Förderinformation',
    editModalTitle: 'Bearbeite Förderinformation',
    title: 'Programm',
    link: 'Externer Link',
    description: 'Beschreibung',
    requirements: 'Vorausetzungen',
    durationAndQuote: 'Dauer und Quote',
    process: 'Förderverfahren',
    deadline: 'Stichtag',
    focus: 'Schwerpunkte',
    contact: 'Ansprechpartner',
    category: 'Kategorie',
    steps: { informations: 'Informationen', preview: 'Vorschau' },
    warnings: {
      noDeadline:
        'Kein Stichtag definiert! Ohne Stichtag ist die Förderinfo grundsätzlich für immer sichtbar. Sie kann aber manuell aktiviert und deaktiviert werden '
    }
  },
  dialogs: {
    deleteConfirm: {
      title: 'Wirklich löschen?',
      message: 'Wollen Sie wirklich die Förderinfo löschen?'
    },
    activate: {
      title: 'Wirklich aktivieren?',
      message: 'Die Förderinfo wird dann für alle sichtbar'
    },
    deactivate: {
      title: 'Wirklich deaktivieren?',
      message: 'Die Förderinfo ist dann nicht mehr sichtbar für alle "Nicht-Admins"'
    }
  },
  filters: {
    myFundings: 'Meine Förderprogramme'
  },
  alerts: {
    errorLoading: 'Die Förderinformationen konnten nicht geladen werden',
    successfulCreate: 'Die Förderinformation wurde erstellt',
    successfulUpdate: 'Die Förderinformation wurde bearbeitet',
    successfulDelete: 'Die Förderinformation wurde gelöscht',
    successfulActivate: 'Die Förderinformation wurde aktiviert',
    successfulDeactivate: 'Die Förderinformation wurde deaktiviert',
    failedCreate: 'Die Förderinformation konnte nicht erstellt werden',
    failedUpdate: 'Die Förderinformation konnte nicht bearbeitet werden',
    failedDelete: 'Die Förderinformation konnte nicht gelöscht werden',
    failedActivate: 'Die Förderinformation konnte nicht aktiviert werden',
    failedDeactivate: 'Die Förderinformation konnte nicht deaktiviert werden'
  }
};

export default de;
export type FundingsTranslation = typeof de;
